import variables from '../variables.module.scss';

const Palette = {
  primary: {
    main: variables.primary,
  },
  secondary: {
    light: variables.secondary,
    main: variables.secondary,
  },
};

export default Palette;
